export const Z_INDEXES = {
  max: 999999,
  modal: 999998,
};
